import React, { useContext, useMemo } from "react";
import { Helmet } from "react-helmet";
import { Language } from "../../App";

/**
 * Global Default Helmet & SEO Fallback.
 * Ensures that if any route or page does NOT have its own custom Helmet/SEO,
 * it automatically falls back to "Ophthalmology Radar" and default metadata.
 */
const GlobalDefaultSEO = () => {
  const { lang } = useContext(Language) || {};

  const isSpanish = useMemo(() => {
    try {
      if (typeof window !== "undefined") {
        const searchParams = new URLSearchParams(window.location.search);
        const urlLang = searchParams.get("lang");
        if (urlLang) {
          const lower = urlLang.toLowerCase().trim();
          if (lower === "es" || lower === "spanish" || lower === "sp") return true;
          if (lower === "en" || lower === "english") return false;
        }
        if (searchParams.has("es") || searchParams.has("spanish")) return true;
        if (window.location.pathname.toLowerCase().includes("/es")) return true;
      }
      const stored = localStorage.getItem("selectedLanguage");
      if (stored === "Spanish") return true;
      if (stored === "English") return false;
      return (
        lang?.code === "es" ||
        (typeof navigator !== "undefined" &&
          Boolean(navigator.language?.toLowerCase()?.startsWith("es")))
      );
    } catch {
      return false;
    }
  }, [lang]);

  const defaultDescription = isSpanish
    ? "Exclusivo para Oftalmólogos. La red social médica para oftalmólogos y profesionales del cuidado visual."
    : "The exclusive medical social network for ophthalmologists and eye care professionals.";

  return (
    <Helmet
      defaultTitle="Ophthalmology Radar"
      titleTemplate="%s"
    >
      <title>Ophthalmology Radar</title>
      <meta name="description" content={defaultDescription} />
    </Helmet>
  );
};

export default React.memo(GlobalDefaultSEO);
